// Copyright (c) Move Closer 2022.

import { Module } from 'vuex'
import { Route } from 'vue-router'

import { RegistryResponse } from '@core'

import { ContentPreviousRoute, ContentState } from './contracts/store'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const storeFactory = (): Module<ContentState, unknown> => ({
  namespaced: true,

  state: () => ({
    previousRoute: null,
    registryResponse: null,
    shouldReCall: true,
    supportedFormats: null
  }),

  mutations: {
    addSupportedFormat (state: ContentState, formats: string): void {
      state.supportedFormats = formats
    },

    clearResponse (state: ContentState): void {
      state.registryResponse = null
    },

    clearSupportedFormats (state: ContentState): void {
      state.supportedFormats = ''
    },

    setReCall (state: ContentState, recall: boolean): void {
      state.shouldReCall = recall
    },

    setResponse (state: ContentState, response: RegistryResponse): void {
      state.registryResponse = response
    },

    setRoute (state: ContentState, route: Route): void {
      state.previousRoute = {
        fullPath: route.fullPath,
        hash: route.hash,
        query: route.query,
        slug: route.params.slug
      }
    }
  },

  getters: {
    hasSupportedFormats: (state:ContentState): boolean => state.supportedFormats !== null,
    previous: (state: ContentState): ContentPreviousRoute | null => state.previousRoute,
    response: (state: ContentState): RegistryResponse | null => state.registryResponse,
    shouldReCall: (state: ContentState): boolean => state.shouldReCall,
    supportedFormats: (state: ContentState): string => state.supportedFormats ?? ''
  }
})
